<script>
import { Article, ArticleTag, Label } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import moment from 'moment'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: PageFormBase,
  data() {
    return {
      livePreview: true,
      tagOptions: [],
      redirectRoute: { name: 'Article List' },
      arrayFields: ['images']
    }
  },
  created() {
    this.fetchTags()
    if (this.form.publication_date === undefined) {
      this.$set(this.form, 'publication_date', moment().format('YYYY-MM-DD'))
    }
  },
  methods: {
    fetchTags() {
      const params = { page_size: 'max' }
      ArticleTag.fetch({}, { params }).then(res => {
        this.tagOptions = res.data.results.map(item => ({
          label: item.name,
          value: item.name
        }))
      })
    },
    getGeneralFields() {
      return [
        new fields.Input({
          label: 'Tytuł',
          modelPath: [this, 'form', 'title'],
          required: true
        }),
        new fields.ForeignKey({
          label: 'Etykieta',
          modelPath: [this, 'form', 'label'],
          labelField: 'name',
          clearable: true,
          service: Label
        }),
        new fields.Date({
          label: 'Data publikacji',
          type: 'date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          modelPath: [this, 'form', 'publication_date'],
          required: true
        }),
        new fields.Select({
          label: 'Tagi',
          modelPath: [this, 'form', 'tags'],
          multiple: true,
          filterable: true,
          allowCreate: true,
          options: this.tagOptions
        }),
        new fields.Input({
          label: 'Zewnętrzny URL',
          modelPath: [this, 'form', 'external_url']
        }),
        new fields.Input({
          label: 'Tekst przy liście artykułów',
          modelPath: [this, 'form', 'show_article_text'],
          help: "Domyślnie: 'Zobacz artykuł'",
          condition:
            process.env.VUE_APP_IS_INNOVATION &&
            JSON.parse(process.env.VUE_APP_IS_INNOVATION)
        }),
        new fields.Switch({
          label: 'Ukryta',
          modelPath: [this, 'form', 'is_hidden']
        }),
        new fields.Switch({
          label: 'Czarno-białe zdjęcia',
          modelPath: [this, 'form', 'is_black_and_white']
        }),
        new fields.Switch({
          label: 'Artykuł przypięty',
          modelPath: [this, 'form', 'is_pinned']
        }),
        {
          component: 'h3',
          innerText: 'Zdjęcia'
        },
        new fields.Formset({
          modelPath: [this, 'form', 'images'],
          items: this.form.images.map((item, i) => ({
            headerLabel: get(item, ['title']),
            fields: [
              new fields.Image({
                label: 'Zdjęcie',
                required: true,
                modelPath: [this, 'form', 'images', i]
              })
            ]
          }))
        })
      ]
    }
  },
  computed: {
    service() {
      return Article
    }
  }
}
</script>
